import defaultSettings from '@/utils/settings'

// 定义所需要的变量
const { showHeader, showTabs, showTags, cachePages } = defaultSettings

const state = {
    showHeader: showHeader,
    showTabs: showTabs,
    showTags: showTags,
    cachePages: cachePages,
    theme: '#409EFF',
}

const mutations = {
    CHANGE_SETTING: (state, { key, value }) => {
        if (state.hasOwnProperty(key)) {
            state[key] = value
        }
    }
}

const actions = {
    // 改变 settings 里面的状态
    changeSetting({ commit }, data) {
        commit('CHANGE_SETTING', data)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

